import { Link } from "react-router";
import Logo from "./logo";
import NavLinks from "./nav-links";
import PropTypes from "prop-types";
import React from "react";

const BigNav = ({ items, entity }) => {
  return (
    <div className="container-fluid nav-inner until-md big-nav">
      <div className="row">
        <div className="col-xs-16">
          <div className="nav-agent-outer">
            <h2 className="agent-name">
              <Link to="/">{entity.displayName}</Link>
            </h2>
            <div className="tagline">{entity.tagline}</div>
            <NavLinks items={items} />
          </div>
        </div>
        <div className="logo-wrapper">
          <Logo entity={entity} />
        </div>
      </div>
    </div>
  );
};

BigNav.propTypes = {
  items: PropTypes.array.isRequired,
  entity: PropTypes.object.isRequired,
};

export default BigNav;



// WEBPACK FOOTER //
// ./src/components/shared/navbar/big-nav.js